<template>
  <!-- 线上考试结果 -->
  <div class="index-container">
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 在线考试 > 线上考试
        <span>> 考试结果</span>
      </div>
      <div class="module-box" v-if="detail && detail.paper">
        <div class="test-name">{{ detail.paper.title }}</div>
        <div class="test-detail">
          试卷说明：本试卷共
          <span>{{ detail.paper.big_total_num }}</span> 大题，
          <span>{{ detail.paper.small_total_num }}</span> 小题， 满分
          <span>{{ detail.paper.total_score }}</span> 分，考试时间
          <span>{{ detail.paper.total_time }}</span> 分钟
        </div>
      </div>
      <div class="people-box">
        <div class="table-box">
          <div>姓名</div>
          <div>开始时间</div>
          <div>结束时间</div>
          <div>答题用时</div>
          <!-- <div>客观题得分</div>
          <div>主观题得分</div>-->
          <div>总得分</div>
        </div>
        <div class="table-box">
          <div>{{ detail.real_name }}</div>
          <div>{{ detail.create_time }}</div>
          <div>{{ detail.end_time }}</div>
          <div>{{ detail.exam_time }}</div>
          <!-- <div>44</div>
          <div>45</div>-->
          <div>{{ detail.score }}</div>
        </div>
      </div>
      <div class="test-content">
        <div class="left-test">
          <div
            class="question-list-box"
            v-for="(item, index) in questionList"
            :key="'ques' + index"
            :id="item.uuid"
          >
            <div class="list-title">{{ index + 1 }}.{{ item.title }}</div>
            <div
              class="answer-text"
              v-for="(obj, key) in item.option"
              :key="'option' + key"
            >
              {{ key }}. {{ obj }}
            </div>
            <div class="select-box">
              <div class="answer-text">
                正确答案
                <span v-for="(obj, key) in item.correct" :key="'cor' + key">
                  {{ obj }}
                </span>
                ，您的答案
                <template v-if="item.type == 3">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="点击下载查看"
                    placement="top-start"
                  >
                    <span
                      class="file-list"
                      v-for="(obj, key) in item.my_correct"
                      :key="'mycor' + key"
                      @click="uploadFile(obj)"
                      ><i class="el-icon-document"></i> 文件{{ key + 1 }}</span
                    >
                  </el-tooltip>
                </template>
                <template v-else>
                  <span
                    v-for="(obj, key) in item.my_correct"
                    :key="'mycor' + key"
                    >{{ obj }}</span
                  >
                </template>
              </div>

              <!-- <div class="right-text">
                错误人数：
                <span>{{item.no_pass }}</span> 错误率：
                <span>{{item.no_pass_rate }}</span>
              </div>-->
            </div>
            <div class="analysis">
              题目解析：{{ item.analysis ? item.analysis : "无" }}
            </div>
          </div>
        </div>
        <div class="right-question">
          <div class="right-title-box">
            <div class="r-title">答题卡</div>
            <!-- <div class="time">24''48''</div> -->
          </div>
          <div class="card-box">
            <div
              class="card-list"
              :class="
                item.my_correct.length
                  ? item.pass == 1
                    ? ''
                    : 'red-active'
                  : 'card-active'
              "
              v-for="(item, index) in questionList"
              :key="index"
              @click="selectQuestion(item, index)"
            >
              {{ item.list_order }}
            </div>
          </div>
          <div class="three-result-box">
            <div>
              <div class="circle"></div>
              正确
            </div>
            <div>
              <div class="circle"></div>
              错误
            </div>
            <div>
              <div class="circle"></div>
              未作
            </div>
          </div>
          <el-pagination
            background
            :pager-count="5"
            layout="prev, pager, next"
            :current-page="page_index"
            :page-size="page_size"
            :total="listTotal"
            @current-change="handleCurrentChange"
          ></el-pagination>

          <!-- 结果显示 -->
          <div class="m-result" v-if="Number(detail.score) < 60">
            <p class="w1">考试结果</p>
            <p class="w2">{{ detail.score }}分</p>
            <p class="w3">本次考试结果不达标，你可以选择重新学习或者再次考试</p>
            <div class="m-btns">
              <div class="m-btn f-center" @click="handleReTest">再次考试</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../api/api";
import { imgUrl } from "../api/index";

export default {
  name: "resultOnline",
  data() {
    return {
      imgUrl: imgUrl,
      questionList: [],
      cardIndex: 0,
      detail: {},
      page_index: 1,
      page_size: 20,
      listTotal: 0,
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    const value = this.$route.query;
    console.log(value);
    if (value) {
      this.paper_uuid = value.id;
      this.getResult();
      this.getTotalScore(value.id);
    }
  },
  methods: {
    uploadFile(file) {
      window.location.href = imgUrl + file;
    },
    selectQuestion(item, index) {
      const scrollIntoViewOptions = {
        behavior: "smooth",
        block: "center",
      };
      document.getElementById(item.uuid).scrollIntoView(scrollIntoViewOptions);
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getResult();
    },
    getResult() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        total_uuid: this.paper_uuid,
      };
      console.log("getResult");
      api.getExamResult(params).then((res) => {
        console.log(res);
        if (res.result) {
          this.questionList = res.result.data;
          this.listTotal = res.result.total;
        }
      });
    },
    getTotalScore(id) {
      api.getTotalScore({ uuid: id }).then((res) => {
        console.log(res);
        if (res.result) {
          this.detail = res.result;
        }
      });
    },
    // 重新考试
    handleReTest() {
      this.$router.push(`/testOnline?id=${this.detail.paper_uuid}&from=retry`);
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 40px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.module-box {
  padding: 40px 42px 32px;
  margin-bottom: 30px;
  background-color: #ffffff;
  .test-name {
    padding-bottom: 20px;
    font-size: 26px;
    color: #333333;
    font-weight: 600;
  }
  .test-detail {
    font-size: 16px;
    color: #777777;
    span {
      color: #333333;
    }
  }
}
.people-box {
  margin-bottom: 30px;
  border: 1px solid #d6d3d3;
  .table-box {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    > div {
      width: calc(100% / 5);
      font-size: 16px;
      text-align: center;
      line-height: 76px;
      border-right: 1px solid #d6d3d3;
      &:last-child {
        border-right: none;
      }
    }
    &:first-child {
      color: #666666;
      border-bottom: 1px solid #d6d3d3;
      background-color: #e4e4e4;
    }
  }
}

.test-content {
  display: flex;
  justify-content: space-between;
}
.left-test {
  width: 64%;
  .question-list-box {
    padding: 44px 34px 34px;
    margin-bottom: 24px;
    background-color: #ffffff;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .list-title {
    padding-bottom: 30px;
    font-size: 16px;
    font-weight: 500;
  }
  .answer-text {
    padding-bottom: 14px;
  }
  .select-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
  }
  .answer-text {
    font-size: 12px;
    color: #999999;
    span {
      color: #333333;
    }
  }
  .file-list {
    cursor: pointer;
    &:hover {
      color: #fb6d0a;
    }
  }
  .right-text {
    font-size: 12px;
    color: #777777;
    span {
      color: #333333;
    }
  }
  /deep/ {
    .el-radio__inner {
      width: 18px;
      height: 18px;
      border-radius: 2px;
      border-color: #979797;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #409eff;
    }
  }
}
.right-question {
  width: 34%;
  padding: 30px 25px;
  background-color: #ffffff;
  .right-title-box {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    .r-title {
      width: 60px;
      padding-bottom: 16px;
      font-size: 20px;
      color: #f1a373;
      font-weight: 600;
      border-bottom: 3px solid #f1a373;
    }
    .time {
      font-size: 18px;
      color: #666666;
    }
  }
  .card-box {
    display: flex;
    flex-wrap: wrap;
    padding: 40px 0 18px;
    border-bottom: 1px solid #d8d8d8;
  }
  .card-list {
    width: 34px;
    height: 34px;
    margin: 0 24px 28px 0;
    font-size: 18px;
    color: #ffffff;
    line-height: 34px;
    text-align: center;
    background-color: #e6e6e6;
    border-radius: 50%;
    border: 1px solid #e8e8e8;
    cursor: pointer;
    &:nth-child(7n) {
      //   margin-right: 0;
    }
  }
  .card-active {
    color: #999999;
    border-color: #c1c1c1;
    background-color: #ffffff;
  }
  .red-active {
    color: #ffffff;
    border-color: #c80000;
    background-color: #c80000;
  }
  .three-result-box {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    > div {
      display: flex;
      font-size: 16px;
      &:first-child {
        .circle {
          background: #e6e6e6;
        }
      }
      &:last-child {
        .circle {
          background: #ffffff;
          border: 1px solid #979797;
        }
      }
    }
    .circle {
      width: 22px;
      height: 22px;
      margin-right: 12px;
      background: #c80000;
      border-radius: 50%;
    }
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-top: 50px;
    text-align: center;
    // button {
    //   width: 42PX;
    //   height: 42PX;
    // }
  }
  //   .el-pager li {
  //     width: 42PX;
  //     height: 42PX;
  //     line-height: 42PX;
  //   }
}
.analysis {
  display: block;
}

.m-result {
  background-color: #ececec;
  padding: 12px;
  margin-top: 30px;
  .w1 {
    font-weight: bold;
    font-size: 20px;
  }
  .w2 {
    font-weight: bold;
    font-size: 18px;
    margin-top: 8px;
  }
  .w3 {
    margin-top: 20px;
  }
  .m-btns {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;
    .m-btn {
      width: 100px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #409eff;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/resultOnline.vue